import React from "react";
import {
  Link,
  ContentAlignment,
  Icon,
  IIconProps,
  Typography
} from "fr-ito-web-react/react/esm";
import { joinClasses } from "ds-core/utils";
import styles from "./styles.module.css";

type Props = {
  variant?: "icon" | "labelWithIcon";
  label?: string;
  icon: IIconProps["name"];
  toggled?: boolean;
  ariaLabel?: string;
  count?: string;
  disabled?: boolean;
  onClick?: (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => void;
};

const Toggle: React.FC<Props> = (props: Props) => {
  const {
    variant,
    label,
    icon,
    toggled,
    ariaLabel,
    count,
    disabled,
    onClick,
    ...remainingProps
  } = props;

  const iconColor = () => {
    if (disabled) {
      return "ito-inactive-icon-color";
    }
    if (toggled && icon === "heart") {
      return "ito-attention-icon-color";
    }
    return "ito-primary-icon-color";
  };
  const buttonToggleIcon = (
    <div className={styles.buttonToggleIconWrapper}>
      <Icon
        name={icon}
        fill={toggled}
        className={
          toggled && icon === "heart"
            ? styles.buttonToggleIconRed
            : styles.buttonToggleIconBlack
        }
        designTokens={{
          colorToken: iconColor()
        }}
      />
    </div>
  );

  if (variant === "icon") {
    return (
      <Link
        element="button"
        className={joinClasses(
          styles.buttonToggle,
          styles.buttonToggleVariantIcon
        )}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...remainingProps}
      >
        <ContentAlignment direction="row" alignment="center">
          {buttonToggleIcon}
          {count && (
            <Typography
              className={styles.buttonToggleCount}
              variant=""
              designTokensS={{
                fontSizeToken: "ito-font-size-10",
                lineHeightToken: "ito-font-lh-1-2",
                fontWeightToken: "ito-font-weight-300"
              }}
              designTokensM={{
                fontSizeToken: "ito-font-size-10",
                lineHeightToken: "ito-font-lh-1-2",
                fontWeightToken: "ito-font-weight-300"
              }}
              designTokensL={{
                fontSizeToken: "ito-font-size-10",
                lineHeightToken: "ito-font-lh-1-2",
                fontWeightToken: "ito-font-weight-300"
              }}
              designTokens={{
                colorToken: disabled
                  ? "ito-inactive-text-color"
                  : "ito-primary-text-color"
              }}
            >
              {count}
            </Typography>
          )}
        </ContentAlignment>
      </Link>
    );
  }
  return (
    <Link
      element="button"
      className={joinClasses(
        styles.buttonToggle,
        styles.buttonToggleVariantLabelWithIcon
      )}
      designTokens={{
        paddingHorizontalToken: "ito-padding-horizontal-8",
        paddingVerticalToken: "ito-padding-vertical-8"
      }}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...remainingProps}
    >
      <ContentAlignment
        className={styles.buttonToggleWrapper}
        direction="row"
        alignment="center"
        spacing="8"
        justifyContent="space-between"
      >
        {label && (
          <Typography
            className={joinClasses(styles.buttonToggleLabel)}
            variant=""
            designTokens={{
              colorToken: disabled
                ? "ito-inactive-text-color"
                : "ito-primary-text-color"
            }}
          >
            {label}
          </Typography>
        )}
        {buttonToggleIcon}
      </ContentAlignment>
    </Link>
  );
};

export default Toggle;
